import { makeStyles, Box, Avatar } from '@material-ui/core'
import React from 'react'
import CustomButton from '../CustomButton'
import CustomDialog from '../CustomDialog'
import CustomHeading from '../CustomHeading'
import CustomImage from '../CustomImage'
import CustomLabel from '../CustomLabel'
import HeadingWithCloseIcon from '../HeadingWithCloseIcon'

const useStyles = makeStyles((theme) => ({
  image: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      height: '60vh',
    },
  },
}))

export default function UploadHeaderDialog({ data = {}, open, handleClose }) {
  const classes = useStyles()
  const keys = Object.keys(data)
  const values = Object.values(data)
  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <HeadingWithCloseIcon heading="Upload Headers" handleClose={handleClose} />
      <hr />
      {keys.map((val, index) => (
        <>
          <Box display="flex" justifyContent="space-between">
            <CustomHeading heading={val} />
            <CustomLabel label={values[index]} />
          </Box>
          <br />
          <br />
        </>
      ))}
    </CustomDialog>
  )
}
